import React, { useContext, useState, useEffect, useRef } from "react";
import { Link as ReactRouterLink, useLocation, useNavigate } from "react-router-dom";
import api from "../../utils/axios";
import {
  Box,
  Button,
  ButtonGroup,
  FormControl,
  FormLabel,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Link,
  Text,
  HStack,
  VStack,
} from "@chakra-ui/react";
import { UserContext } from "../../context/UserContext";
import { isUser } from "../../utils/helpers";

function Login() {
  const { setUser, language } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const pwRef = useRef(null);

  const [registrationIsOpen, setRegistrationIsOpen] = useState(false);
  const [eventExists, setEventExists] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailFound, setEmailFound] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);

  const [forgetPwdMsg, setForgetPwdMsg] = useState("");
  const [showLogin, setShowLogin] = useState(true);

  useEffect(() => {
    api.get("/api/events/upcoming").then((res) => {
      if (res.data.length > 0) {
        setEventExists(true);
        setRegistrationIsOpen(res.data[0].isOpen);
        // When registration is not open, "Forget password" function does not work. This could be a bug in the code.
        // In this case, we will hide the "Forget Password" button and error message will be tailored accordingly.
        // if (registrationIsOpen) {
        //   language === "en" ? setForgetPwdMsg(`or click on Forget Password to reset your password`) : setForgetPwdMsg(`或者 点擊在下方的"忘記了密碼"按鈕, 重新設定您的密碼`);
        // } else {
        //   (language === "en" ? setForgetPwdMsg(`or wait for registration to open, then try again!`) : setForgetPwdMsg(`或等註冊開放後再試!`));
        // }
      }
    });
  }, []);

  useEffect(() => {
    // When registration is not open, "Forget password" function does not work. This could be a bug in the code.
    // In this case, we will hide the "Forget Password" button and error message will be tailored accordingly.
    if (registrationIsOpen) {
      language === "en" ? setForgetPwdMsg(`Please enter the password again or click on Forget Password to reset your password`) : setForgetPwdMsg(`請重新輸入密碼 或者 点擊在下方的"忘記了密碼"按鈕, 重新設定您的密碼`);
    } else if (eventExists) {
      (language === "en" ? setForgetPwdMsg(`Please enter the password again or click on Forget Password to reset your password`) : setForgetPwdMsg(`請重新輸入密碼 或者 点擊在下方的"忘記了密碼"按鈕, 重新設定您的密碼`));
    } else {
      (language === "en" ? setForgetPwdMsg(`Please wait for registration to open, then try again!`) : setForgetPwdMsg(`請您等註冊開放後再試!`));
    }
  }, [registrationIsOpen, eventExists, language]);

  useEffect(() => {
    pwRef?.current?.focus();
  }, [emailFound]);

  useEffect(() => {
    if (location.state?.reset) {
      setErrorMessage("");
      setEmail("");
      setEmailFound(false);
      setPassword("");
    }
  }, [location.state]);

  async function handleSubmit(e) {
    e.preventDefault();

    if (email.length === 0) {
      setErrorMessage((language === "en" ? "Email cannot be empty." :
        "電郵地址不能空白"));
      return;
    }

    if (emailFound && password.length === 0) {
      setErrorMessage((language === "en" ? "Password cannot be empty." :
        "密碼不能空白"));
      return;
    }

    try {
      const res = await api.post("/api/auth/login", {
        email,
        password,
      });

      if (res.status === 202 && !emailFound) {
        setEmailFound(true);
        setErrorMessage("");
        return;
      }

      setUser(res.data);
      localStorage.setItem("userData", JSON.stringify(res.data));
      if (isUser(res.data)) {
        navigate("/registration");
      } else {
        navigate("/admin/registration");
      }
    } catch (err) {
      let errMsg = err.response?.data?.message;
      setErrorMessage(errMsg || "Unknown error occurred");
      console.log(err);
    }
  }

  return (
    <>
      <Heading brand="brand" textAlign="center" margin="20px">
        {language === "en" ? "Login" : "登入"}
      </Heading>
      {eventExists && !registrationIsOpen && (
        <Box textAlign="center" margin="20px" padding="20px" bg="yellow.100" borderRadius="md">
          <Heading as="h4" size="md" textAlign="center" color="red" marginBottom="10px">
            {language === "en" ? "Registration is now closed" : "報名已關閉"}
          </Heading>
          <Text textAlign="center" color="gray.700">
            {language === "en"
              ? "Registration is now closed. You can still login to see your registration information or to cancel your registration by choosing 'I will not attend' option for your family."
              : "報名已關閉。您仍然可以登入查看您的註冊信息，或選擇「不參加」選項取消您家庭的註冊。"}
          </Text>
        </Box>
      )}
      {!eventExists && (
        <Heading as="h3" size="md" textAlign="center" color="red" margin="20px">
          {language === "en" ? "Registration is not open." :
            "報名註冊尚未開放"}
        </Heading>
      )}
      <Box display="flex" alignItems="center" justifyContent="center" hidden={!showLogin}>
        <form onSubmit={handleSubmit}>
          <VStack spacing={4}>
            {errorMessage.length > 0 &&
              (errorMessage != "Email not found." ? (
                <>
                  <Text
                    as="b"
                    color="red"
                    display="flex"
                    flexDirection="row"
                    margin={1}
                  >
                    {errorMessage}
                  </Text>
                  <Text
                    as="b"
                    color="red"
                    display="flex"
                    flexDirection="row"
                    margin={1}
                    fontSize="sm"
                  >
                    {/* {language === "en" ? "Please enter the password again or click on Forget Password to reset your password" :
                        `請重新輸入密碼 或者 点擊在下方的"忘記了密碼"按鈕, 重新設定您的密碼`} */}
                    {language === "en" ? `${forgetPwdMsg}` :
                      `${forgetPwdMsg}`}
                  </Text>
                </>
              ) : (
                <HStack spacing={1}>
                  <Text as="b" color="red">
                    {language === "en" ? "Email not found, please enter the correct email or" :
                      `找不到您的電郵地址, 請輸入正確的電郵地址 或者 点擊`}
                  </Text>
                  <Link
                    as={ReactRouterLink}
                    color="blue"
                    fontWeight="bold"
                    to="/signup"
                  >
                    {language === "en" ? "sign up." : "登記"}
                  </Link>
                </HStack>
              ))}

            <FormControl >
              <FormLabel>
                {language === "en" ? "Email Address" : "电邮網址"}
              </FormLabel>
              <Input
                type="text"
                placeholder={language === "en" ? "Email Address" : "电子邮件"}
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                isDisabled={emailFound}
              />
            </FormControl>
            <FormControl hidden={!emailFound}>
              <FormLabel>{language === "en" ? "Password" : "密码"}</FormLabel>
              <InputGroup>
                <Input
                  ref={pwRef}
                  type={passwordShow ? "text" : "password"}
                  placeholder={language === "en" ? "Password" : "密碼"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <InputRightElement width="4.5rem">
                  <Button
                    h="1.75rem"
                    size="sm"
                    onClick={() => {
                      setPasswordShow(!passwordShow);

                      // Set timeout of 0 to ensure input type changes before setting cursor
                      setTimeout(() => {
                        if (pwRef.current) {
                          pwRef.current.focus();
                          pwRef.current.selectionStart =
                            pwRef.current.value.length;
                        }
                      }, 0);
                    }}
                  >
                    {passwordShow ? "Hide" : "Show"}
                  </Button>
                </InputRightElement>
              </InputGroup>
            </FormControl>
            <ButtonGroup spacing="6" alignItems="center">
              <Button type="submit" colorScheme="blue">
                {language === "en" ? "Submit" : "提交"}
              </Button>
              <ReactRouterLink to="/forgot-password" hidden={!registrationIsOpen}>
                <Button size="sm">
                  {language === "en" ? "Forgot Password" : "忘记了密码"}
                </Button>
              </ReactRouterLink>
            </ButtonGroup>
          </VStack>
        </form>
      </Box>
    </>
  );
}

export default Login;
